import dayjs from 'shared/helpers/dayjs';

export default function parseReportDateParam(search: string): Date {
  const parsed = dayjs(new URLSearchParams(search).get('date'));
  return parsed.isValid() ? parsed.toDate() : new Date();
}
